import React from "react";

const Loader = () => {
  return <div style={bgStyles}></div>;
};

export default Loader;

const bgStyles = {
  backgroundImage: `url(/prelodar.gif)`,
  height: "90vh",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  width:'95%'
};
